// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"9d566d48","911":"9d566d48"}[chunkId] + ".chunk.css";
};